import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) toast.error("Invalid reset link — the token is missing");
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== pw2) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("password reset ♥ log in with the new one");
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not reset password");
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-ink min-h-screen flex items-center justify-center px-5 py-12" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <p className="scribble text-hotpink text-2xl mb-2 rotate-[-2deg] inline-block">fresh start</p>
        <h1 className="brush-title text-5xl md:text-6xl text-white mb-8">NEW <span className="text-hotpink">PASSWORD.</span></h1>
        {done ? (
          <div className="bg-coal border border-hotpink/40 p-7">
            <p className="font-outfit text-white text-base">Done ✓ redirecting to login…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-coal border border-white/10 p-7 space-y-5">
            <div>
              <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">new password</label>
              <input
                data-testid="reset-new-password"
                type="password"
                required
                minLength={6}
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                className="w-full bg-ink border border-white/15 px-4 py-3 text-white font-outfit focus:border-hotpink focus:outline-none"
                placeholder="at least 6 characters"
              />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">confirm</label>
              <input
                data-testid="reset-confirm-password"
                type="password"
                required
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
                className="w-full bg-ink border border-white/15 px-4 py-3 text-white font-outfit focus:border-hotpink focus:outline-none"
                placeholder="type it again"
              />
            </div>
            <button
              type="submit"
              disabled={loading || !token}
              data-testid="reset-submit"
              className="w-full bg-hotpink hover:bg-hotpink_dark text-white font-outfit font-extrabold uppercase tracking-widest text-sm px-6 py-4 shadow-[4px_4px_0px_#FFFFFF] hover:shadow-[6px_6px_0px_#FFFFFF] transition-all disabled:opacity-60"
            >
              {loading ? "..." : "reset password"}
            </button>
            <p className="text-white/40 text-xs font-outfit text-center">
              <Link to="/login" data-testid="reset-to-login" className="text-hotpink underline underline-offset-4">back to login</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
